'use strict';
const pbPlacements = require('../../components/shared/prebidPlacementMap.json');

/**
 * @param {string} slot base slot name: 'vdp.inline.10' | 'vdp.inline.20'
 * @param {object} context must have listing DTO
 * @param {function} checkForShouldShow a function to check if we should show the ads
 * @param {string} prefix for 6427/ which is not needed to market places.
 */
/* istanbul ignore next */
module.exports = function (slot, context, checkForShouldShow, prefix) {

    const listingDto = context.listingData && context.listingData.listingDetailDto ? context.listingData.listingDetailDto : context.listingDto;

    let lowerCaseStockTypeCode = listingDto && listingDto.stockTypeCode ? listingDto.stockTypeCode.toLowerCase() : null;
    if ((listingDto.modelYear >= new Date().getFullYear() - 4) && !listingDto.isCpoVehicle && !listingDto.isNewCarStockType){
        lowerCaseStockTypeCode = "cmy";
    }

    if (listingDto.privatePartyListing){
        slot = "seller." + slot;
    }

    const slotName = (prefix === undefined ? '6427/'  : prefix) + `buy.${lowerCaseStockTypeCode}/${slot}`;
    return {
        shouldShowAd: checkForShouldShow ? checkForShouldShow(context) : true,
        slotName,
        placement: pbPlacements[slotName]
    };
};
